import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Components
import DynamicPopupLink from "./DynamicPopupLink";
import Spinner from "../Spinner";

const propTypes = {
  importantInfoPopupData: PropTypes.object
};

const Wrapper = styled.div`
  font-size: 14px;
`;
const Header = styled.div`
  font-size: 1.3em;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

function ImportantInformationFlightLookup({ importantInfoPopupData }) {
  if (!importantInfoPopupData) {
    return (
      <React.Fragment>
        <Header> Important Information </Header>
        <Spinner />
      </React.Fragment>
    );
  }

  const {
    flight_schedule,
    bag_spec_requirements,
    notice_of_incorp,
    frequent_flyer,
    check_in,
    internation_travel,
    seat_assignments
  } = importantInfoPopupData;
  return (
    <Wrapper>
      <Header>Important Information</Header>
      <p>
        Since airlines change flight schedules from time to time, it is the
        passengers responsibility to call the airline and confirm flight
        information prior to departure. We recommend that you arrive at the
        airport a minimum of 90 minutes in advance of departure for domestic
        flights. If you choose not to take your outbound flight, the airlines
        will consider you a “no show” and will automatically cancel the
        remainder of your reservation. Your tickets will not be honored and no
        refunds will be granted for the unused portion of your trip. For more
        helpful tips and travel advice, click on the topics below:
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={flight_schedule}
          linkText="Flight Schedule"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={bag_spec_requirements}
          linkText="Baggage/Special requirements"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={notice_of_incorp}
          linkText="Notice of Incorporated Terms"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={frequent_flyer}
          linkText="Frequent Flyer and Loyalty Programs"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={check_in}
          linkText="Airport Check-In and Security"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={internation_travel}
          linkText="International Travel"
        />
      </p>
      <p>
        <DynamicPopupLink
          popUpContent={seat_assignments}
          linkText="Seat Assignments"
        />
      </p>
    </Wrapper>
  );
}

ImportantInformationFlightLookup.propTypes = propTypes;

export default ImportantInformationFlightLookup;



// WEBPACK FOOTER //
// ./src/components/ImportantInformationFlightLookup/index.js